import { SECTION_NAMES } from '@/config/widget';
import { derivedThemeValues } from '@/services/widgetTheme/derivedValues';
export const TENSION = 0;
export const CHART = derivedThemeValues(_ref => {
  let {
    theme
  } = _ref;
  return {
    grid: {
      color: theme.color.border
    },
    dataLabel: {
      color: theme.color.bodyFont,
      backgroundColor: theme.color.secondary
    },
    [SECTION_NAMES.gaugeChart]: {
      arc: {
        emptyColor: '#1d2127'
      },
      title: {
        color: theme.color.white
      }
    },
    [SECTION_NAMES.lineChart]: {
      gradient: {
        start: 1,
        startOpacity: 0.58
      }
    },
    [SECTION_NAMES.radarChart]: {
      gradient: {
        startOpacity: 0.2,
        stop: 0,
        stopOpacity: 0.1
      }
    }
  };
});